import {
  COMMUNITY_LIST,
  OPEN_COMMUNITY_MODAL,
  LOAD_EDIT_COMMUNITY_DATA,
  COMMUNITY_REQUESTED_USERS_LIST,
} from "ActionsCommunity";

export function communityList(state = {}, action) {
  switch (action.type) {
    case COMMUNITY_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function addCommunityModal(state = {}, action) {
  switch (action.type) {
    case OPEN_COMMUNITY_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function editCommunity(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_COMMUNITY_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function requestedCommunityMemberList(state = {}, action) {
  switch (action.type) {
    case COMMUNITY_REQUESTED_USERS_LIST:
      return action.payload;
    default:
      return state;
  }
}
